import React, { Component } from 'react'
import { Link, RouteComponentProps } from 'react-router-dom'

import get from 'lodash/get'
import isNil from 'lodash/isNil'
import defaultTo from 'lodash/defaultTo'

import { sexOptions, employeeCountOptions, companyTypeOptions, countryOptions } from 'data'

import PageLayout from 'components/layout/pageLayout'
import Head from 'components/layout/head'
import Input from 'components/ui/input'
import Button from 'components/ui/button'
import Radio from 'components/ui/radio'
import Accordion from 'components/layout/accordion'
import Select from 'components/ui/select'
import CheckBox from 'components/ui/checkBox'
import { ChildProps } from 'react-apollo'
import { InputProps, Response } from '.'

interface SignUpProps extends ChildProps<InputProps, Response>, RouteComponentProps {
  data: any
}

interface IErrorObject {
  [k: string]: string | null
}

type SignUpState = {
  success: boolean
  errors: IErrorObject | null
  company: string | null
  sex: string | null
  employeeCount: number | null
  firstname: string | null
  lastname: string | null
  companyType: string | null
  // source: string | null
  street: string | null
  phone: string | null
  zipCode: string | null
  email: string | null
  city: string | null
  fax: string | null
  country: string | null
  webAdress: string | null
  termsOfUse: boolean
  newsletter: boolean
}

class SignUp extends Component<SignUpProps, SignUpState> {
  constructor(props: SignUpProps) {
    super(props)
    this.state = {
      success: false,
      errors: null,
      company: null,
      sex: 'Herr',
      employeeCount: null,
      firstname: null,
      lastname: null,
      companyType: null,
      // source: null,
      street: null,
      phone: null,
      zipCode: null,
      email: null,
      city: null,
      fax: null,
      country: 'AT',
      webAdress: null,
      termsOfUse: false,
      newsletter: false,
    }
  }

  handleSignUp = () => {
    const { mutate } = this.props

    const errors = {
      company: this.state.company === null ? 'Error Message.' : null,
      company_length:
        this.state.company !== null && this.state.company.length > 25
          ? 'Das Feld Büro/Firma darf maximal 25 Zeichen lang sein.'
          : null,
      sex: this.state.sex === null ? 'Error Message.' : null,
      firstname: this.state.firstname === null ? 'Error Message.' : null,
      lastname: this.state.lastname === null ? 'Error Message.' : null,
      companyType: this.state.companyType === null ? 'Error Message.' : null,
      // source: this.state.source === null ? 'Error Message.' : null,
      street: this.state.street === null ? 'Error Message.' : null,
      phone: this.state.phone === null ? 'Error Message.' : null,
      zipCode: this.state.zipCode === null ? 'Error Message.' : null,
      email: this.state.email === null ? 'Error Message.' : null,
      city: this.state.city === null ? 'Error Message.' : null,
      country: this.state.country === null ? 'Error Message.' : null,
      termsOfUse: !this.state.termsOfUse ? 'Bitte akzeptieren Sie die Nutzungsbedingungen.' : null,
    }

    const hasErrors = Object.values(errors).find((error) => {
      if (error) return true
      return false
    })

    if (hasErrors) {
      this.setState({ errors, success: false })
    } else {
      if (mutate) {
        mutate({
          variables: { ...this.state },
        })
          .then((res) => {
            // Register was sucessfull
            if (get(res, 'data.registerUser')) {
              this.setState({ errors: null, success: true })
            } else {
              this.setState({
                errors: {
                  api: 'Error Message',
                },
                success: false,
              })
            }
          })
          .catch(() => {
            const error = JSON.parse(
              get(this.props, 'result.error.graphQLErrors[0].message.message', null),
            )

            this.setState({
              errors: {
                api: this.translateApiErrorCode(get(error, 'code', undefined)),
              },
              success: false,
            })
          })
      }
    }
  }

  translateApiErrorCode(code: number | undefined) {
    switch (code) {
      case 108:
        return 'Die E-Mail Adresse wird bereits verwendet.'
      case 161:
        return 'Die Postleitzahl darf maximal 10 Zeichen lang sein.'
      case 162:
        return 'Das Feld Büro/Firma darf maximal 30 Zeichen lang sein.'
      default:
        return 'Ein Fehler ist aufgetreten.'
    }
  }

  getErrorMessage = () => {
    const { errors } = this.state
    const apiError = get(errors, 'api', undefined)
    const company_length_error = get(errors, 'company_length', undefined)
    if (isNil(errors)) {
      return undefined
    }

    if (!isNil(apiError)) {
      return apiError
    } else if (company_length_error !== null) {
      return company_length_error
    } else {
      return 'Pflichtfelder ausfüllen!'
    }
  }

  render() {
    const {
      success,
      errors,
      company,
      firstname,
      lastname,
      sex,
      street,
      phone,
      email,
      city,
      fax,
      country,
      webAdress,
    } = this.state
    const { history } = this.props

    return (
      <PageLayout pageTitle="Neues Konto erstellen">
        <Head
          headline="Neues Konto erstellen"
          subheadline="Zurück zur Startseite"
          linkTo="/"
          error={errors ? true : false}
          message={this.getErrorMessage()}
        />
        {success ? (
          <div className="flex flex-col items-start my-65 px-48">
            <p className="block font-400 text-15 tracking-0.1 text-black leading-22">
              Ihr Konto wurde erfolgreich erstellt.
            </p>
            <br></br>
            <Button secondary onClick={() => history.push('/login')}>
              Zum Login
            </Button>
          </div>
        ) : (
          <>
            <div className="my-65 px-48">
              <p className="font-400 text-15 tracking-0.1 text-black leading-22">
                <span
                  dangerouslySetInnerHTML={{
                    __html:
                      process.env.REACT_APP_ENV === 'rigips'
                        ? 'Melden Sie sich jetzt kostenfrei an, um Rigips-Systeme online kalkulieren zu können.'
                        : 'Jetzt <b>kostenlos</b> anmelden und mit ABK calcKIT online kalkulieren.',
                  }}
                />
              </p>
            </div>

            <div className="px-48">
              <div className="flex">
                <div className="w-4/12 flex items-end">
                  <Input
                    name="company"
                    label="Büro/Firma"
                    required
                    value={company}
                    leftAlign
                    error={errors && (errors.company || errors.company_length) ? 'true' : undefined}
                    onChange={(value) => this.setState({ company: value ? String(value) : null })}
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end">
                  <Radio
                    label="Ansprechpartner"
                    required
                    value={defaultTo(sex, sexOptions[0].value)}
                    options={sexOptions}
                    error={errors && errors.sex ? errors.sex : undefined}
                    onChange={(value) => this.setState({ sex: value ? String(value) : null })}
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end">
                  {/* <Select
                    label="Wie sind Sie auf ABKit aufmerksam geworden?"
                    error={errors && errors.source ? errors.source : undefined}
                    onChange={(option) =>
                      this.setState({ source: option.value ? String(option.value) : null })
                    }
                    required
                    defaultValue=""
                    options={sourceOptions}
                  /> */}
                </div>
              </div>

              <div className="flex mt-34.5 flex items-end">
                <div className="w-4/12">
                  <Select
                    label="Anzahl Mitarbeiter"
                    error={errors && errors.employeeCount ? errors.employeeCount : undefined}
                    onChange={(option) =>
                      this.setState({ employeeCount: option.value ? Number(option.value) : null })
                    }
                    defaultValue=""
                    options={employeeCountOptions}
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end">
                  <Input
                    name="firstname"
                    label="Vorname"
                    required
                    value={firstname}
                    leftAlign
                    error={errors && errors.firstname ? errors.firstname : undefined}
                    onChange={(value) => this.setState({ firstname: value ? String(value) : null })}
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end"></div>
              </div>

              <div className="flex mt-34.5 flex items-end">
                <div className="w-4/12">
                  <Select
                    label="Art der Firma"
                    error={errors && errors.companyType ? errors.companyType : undefined}
                    onChange={(option) =>
                      this.setState({ companyType: option.value ? String(option.value) : null })
                    }
                    required
                    defaultValue=""
                    options={companyTypeOptions}
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end">
                  <Input
                    name="lastname"
                    label="Nachname"
                    required
                    value={lastname}
                    leftAlign
                    error={errors && errors.lastname ? errors.lastname : undefined}
                    onChange={(value) => this.setState({ lastname: value ? String(value) : null })}
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end"></div>
              </div>

              <div className="flex mt-34.5 flex items-end">
                <div className="w-4/12">
                  <Input
                    name="street"
                    label="Straße"
                    leftAlign
                    value={street}
                    error={errors && errors.street ? errors.street : undefined}
                    onChange={(value) => this.setState({ street: value ? String(value) : null })}
                    required
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end">
                  <Input
                    name="phone"
                    label="Telefon"
                    required
                    value={phone}
                    leftAlign
                    error={errors && errors.phone ? errors.phone : undefined}
                    onChange={(value) => this.setState({ phone: value ? String(value) : null })}
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end"></div>
              </div>

              <div className="flex mt-34.5 flex items-end">
                <div className="w-4/12">
                  <Input
                    type="number"
                    name="zipCode"
                    min={0}
                    max={999999999}
                    label="PLZ"
                    leftAlign
                    value={null}
                    error={errors && errors.zipCode ? errors.zipCode : undefined}
                    onChange={(value) => this.setState({ zipCode: value ? String(value) : null })}
                    required
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end">
                  <Input
                    name="email"
                    type="email"
                    label="E-Mail"
                    required
                    value={email}
                    leftAlign
                    error={errors && errors.email ? errors.email : undefined}
                    onChange={(value) => this.setState({ email: value ? String(value) : null })}
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end"></div>
              </div>

              <div className="flex mt-34.5 flex items-end">
                <div className="w-4/12">
                  <Input
                    name="city"
                    label="Ort"
                    leftAlign
                    value={city}
                    error={errors && errors.city ? errors.city : undefined}
                    onChange={(value) => this.setState({ city: value ? String(value) : null })}
                    required
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end">
                  <Input
                    name="fax"
                    label="Fax"
                    value={fax}
                    leftAlign
                    onChange={(value) => this.setState({ fax: value ? String(value) : null })}
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end"></div>
              </div>

              <div className="flex mt-34.5 flex items-end">
                <div className="w-4/12">
                  <Select
                    label="Land"
                    options={countryOptions}
                    defaultValue={country ? country : undefined}
                    required
                    error={errors && errors.country ? errors.country : undefined}
                    onChange={(option) => this.setState({ country: String(option.value) })}
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end"></div>
                <div className="w-4/12 ml-30 flex items-end"></div>
              </div>

              <div className="flex mt-34.5 flex items-end">
                <div className="w-4/12">
                  <Input
                    name="webAdress"
                    label="Website"
                    leftAlign
                    value={webAdress}
                    onChange={(value) => this.setState({ webAdress: value ? String(value) : null })}
                  />
                </div>
                <div className="w-4/12 ml-30 flex items-end"></div>
                <div className="w-4/12 ml-30 flex items-end"></div>
              </div>
            </div>

            <div className="mt-65 px-48">
              {process.env.REACT_APP_ENV === 'rigips' ? (
                <>
                  <p className="font-400 text-15 tracking-0.1 text-black leading-22">
                    <b className="block mb-10">
                      Mengenermittlung und Systemsuche – HORST Nutzungsbedingungen
                    </b>
                    Mit Absenden Ihrer Anmeldung erteilen Sie den österreichischen Saint-Gobain
                    Firmen (Saint-Gobain Rigips Austria GesmbH, Saint-Gobain ISOVER Austria GmbH und
                    Saint-Gobain Weber Terranova GmbH) Ihre Einwilligung, Ihre personenbezogenen
                    Daten zu eigenen Informationszwecken zu nutzen. Hierzu gehören z. B. die
                    Zusendung von Informationen über Produkte, Anwendungen, Arbeitshilfen oder
                    Veranstaltungen sowie Kontaktaufnahme durch unseren Außendienst, wobei diese
                    Maßnahmen sowohl auf elektronischem Weg (per eMail), telefonisch oder in Form
                    von Printmedien erfolgen können. Eine Weitergabe an Dritte erfolgt an den
                    Serverbetreiber zur Speicherung der Daten.
                  </p>
                  <br />

                  <p className="font-400 text-15 tracking-0.1 text-black leading-22">
                    Ihr Einverständnis mit der vorstehend beschriebenen Datennutzung können Sie
                    jederzeit schriftlich (Saint-Gobain Rigips Austria GesmbH, Unterkainisch 24,
                    8990 Bad Aussee) oder per eMail an{' '}
                    <a className="link text-15" href="mailto:rigips.austria@saint-gobain.com">
                      rigips.austria(at)saint-gobain.com
                    </a>{' '}
                    widerrufen. Ergänzend gelten die "Nutzungsbedingungen für die Internet-Seite{' '}
                    <a
                      className="link text-15"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.rigips.at"
                    >
                      www.rigips.at
                    </a>
                    ".
                  </p>
                  <br />
                  <p className="font-400 text-15 tracking-0.1 text-black leading-22">
                    Unser Dienstleister (Serverbetreiber) für den Service Mengenermittlung und
                    Systemsuche – HORST ist die Firma ib-data GmbH, Softwareentwicklung für
                    Architektur und Bauwesen, Hasnerstraße 118, A-1160 Wien.<br></br>Die
                    österreichischen Saint-Gobain Firmen (Saint-Gobain Rigips Austria GesmbH,
                    Saint-Gobain ISOVER Austria GmbH und Saint-Gobain Weber Terranova GmbH)
                    unternehmen alle zumutbaren Schritte, um die Aktualität, Richtigkeit, Wahrheit
                    und Vollständigkeit der präsentierten Informationen zum Zeitpunkt der
                    Veröffentlichung auf dieser Website sicherzustellen. Sie übernehmen jedoch keine
                    Gewähr für die von ihnen veröffentlichten Informationen, Inhalte,
                    Dienstleistungen, Angebote oder Produkte. Bei den angegebenen Preisen handelt es
                    sich um Richtpreise. Preisänderungen werden vorbehalten.
                  </p>
                  <br />
                  <p className="font-400 text-15 tracking-0.1 text-black leading-22">
                    Die österreichischen Saint-Gobain Firmen (Saint-Gobain Rigips Austria GesmbH,
                    Saint-Gobain ISOVER Austria GmbH und Saint-Gobain Weber Terranova GmbH)
                    übernehmen keine Haftung für irgendwelche direkten oder indirekten Schäden oder
                    Folgeschäden, die im Zusammenhang mit der Benutzung der Website oder der
                    Benutzung des Mengenermittlungstools HORST bei Benutzern oder Dritten entstehen
                    könnten. Die österreichischen Saint-Gobain Firmen (Saint-Gobain Rigips Austria
                    GesmbH, Saint-Gobain ISOVER Austria GmbH und Saint-Gobain Weber Terranova GmbH)
                    übernehmen ausserdem keine Verantwortung und geben keine Gewähr dafür, dass die
                    Funktionen auf dieser Website nicht unterbrochen werden, fehlerlos oder frei von
                    schädlichen Bestandteilen (z.B. Viren) sind.
                  </p>
                  <br />
                  <p className="font-400 text-15 tracking-0.1 text-black leading-22">
                    Unter bestimmten Umständen kann es entweder für die österreichischen
                    Saint-Gobain Firmen erforderlich sein, die Website oder der Benutzung des
                    Mengenermittlungstools HORST teilweise oder vollständig einzustellen, diese
                    Nutzungsbedingungen aufzulösen, Ihr Benutzerkonto oder Ihre Zugriffsrechte zu
                    sperren oder Sie als Benutzer auszuschließen. Es kann unter diesen Umständen
                    vorkommen, dass Sie nicht auf Ihr Benutzerkonto oder Ihre Einstellungen
                    zugreifen können. Wir behalten uns das Recht vor, unsere Dienste jederzeit
                    auszusetzen oder einzustellen, mit oder ohne Grund und mit oder ohne
                    Ankündigung.
                  </p>
                </>
              ) : (
                ''
              )}
            </div>

            <div className="px-48 mt-45">
              <CheckBox
                label={
                  process.env.REACT_APP_ENV === 'rigips' ? (
                    <p className="font-500">
                      Ich habe die Nutzungsbedingungen, die obige Ergänzung zu den
                      Nutzungsbedingungen und die Datenschutzerklärung gelesen und akzeptiere diese.
                    </p>
                  ) : (
                    <p className="font-500">
                      Ich habe die{' '}
                      <Link className="link" to="/faq/terms-of-use">
                        Nutzungsbedingungen
                      </Link>{' '}
                      gelesen und erkläre mich mit der Verarbeitung meiner persönlichen Daten gemäß{' '}
                      <a className="link" href="https://www.abk.at/datenschutz/">
                        Datenschutzerklärung
                      </a>{' '}
                      einverstanden.
                    </p>
                  )
                }
                error={errors && errors.termsOfUse ? errors.termsOfUse : undefined}
                onChange={(value) => this.setState({ termsOfUse: value })}
              />
              <div className="mt-10">
                <CheckBox
                  label={
                    process.env.REACT_APP_ENV === 'rigips' ? (
                      <p className="font-500">
                        Hier den Rigips Newsletter bestellen und nichts mehr verpassen.
                      </p>
                    ) : (
                      <p className="font-500">
                        Ich möchte durch den{' '}
                        <a
                          className="link"
                          href="https://www.abk.at/news/abk-newsletter/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          ABK- und Baudaten-Newsletter
                        </a>{' '}
                        regelmäßig über Neuigkeiten im Bausoftware- und Baumanagementbereich
                        informiert werden und erkläre mich damit einverstanden, dass die ib-data
                        GmbH mir regelmäßig Informationen über Produktneuheiten, Veranstaltungen
                        usw. per E-Mail zusendet. Meine Einwilligung kann ich jederzeit gegenüber
                        der ib-data GmbH widerrufen (per E-Mail an abkinfo@abk.at oder an die im
                        Impressum angegebenen Kontaktdaten).
                      </p>
                    )
                  }
                  error={errors && errors.newsletter ? errors.newsletter : undefined}
                  onChange={(value) => this.setState({ newsletter: value })}
                />
              </div>
              <div className="ml-30 mt-10">
                {process.env.REACT_APP_ENV === 'rigips' && (
                  <p className="font-400 text-black text-13 leading-19 tracking-0.1">
                    Ihre Einwilligung in den Versand ist jederzeit frei widerruflich (per E-Mail an{' '}
                    <a
                      className="link"
                      href={
                        process.env.REACT_APP_ENV === 'rigips'
                          ? 'mailto:info@rigips.de'
                          : 'mailto:abkinfo@abk.at'
                      }
                    >
                      {process.env.REACT_APP_ENV === 'rigips' ? 'info@rigips.de' : 'abkinfo@abk.at'}
                    </a>{' '}
                    oder an die im{' '}
                    <a
                      className="link"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        process.env.REACT_APP_ENV === 'rigips'
                          ? 'https://www.rigips.at/impressum'
                          : 'https://www.abk.at/impressum/'
                      }
                    >
                      Impressum
                    </a>{' '}
                    angegebenen Kontaktdaten). Der News-Versand erfolgt entsprechend unserer{' '}
                    <a
                      className="link"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        process.env.REACT_APP_ENV === 'rigips'
                          ? 'https://www.rigips.at/impressum'
                          : 'https://www.abk.at/datenschutz/'
                      }
                    >
                      Datenschutzerklärung
                    </a>{' '}
                    und zur Bewerbung eigener Produkte und Dienstleistungen, die unter folgendem
                    Link näher beschrieben werden:{' '}
                    <a
                      className="link"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        process.env.REACT_APP_ENV === 'rigips'
                          ? 'https://www.rigips.de/aktuelles/newsletter'
                          : 'https://www.abk.at/news/'
                      }
                    >
                      {process.env.REACT_APP_ENV === 'rigips' ? 'Rigips News' : 'ABKit News'}
                    </a>
                    .
                  </p>
                )}
                {process.env.REACT_APP_ENV !== 'rigips' && (
                  <p className="font-400 text-black text-13 leading-19 tracking-0.1">
                    Meine Einwilligung kann ich jederzeit gegenüber der ib-data GmbH widerrufen (per
                    E-Mail an{' '}
                    <a className="link" href="mailto:abkinfo@abk.at">
                      abkinfo@abk.at
                    </a>{' '}
                    oder an die im{' '}
                    <a
                      className="link"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.abk.at/impressum/"
                    >
                      Impressum
                    </a>{' '}
                    angegebenen Kontaktdaten).
                  </p>
                )}
              </div>
              <div className="mt-45 flex justify-center">
                <Button onClick={this.handleSignUp} primary>
                  Angaben jetzt übermitteln
                </Button>
              </div>
            </div>

            <div className="my-65">
              {process.env.REACT_APP_ENV === 'rigips' && (
                <Accordion preExpanded heading="Haftungsausschluss">
                  <div className="px-48">
                    <p className="font-400 text-black text-15 leading-22 tracking-0.1">
                      {process.env.REACT_APP_ENV === 'rigips'
                        ? 'Dieses Programm wurde sorgfältig programmiert und die Produktdaten sorgfältig zusammengestellt. Dennoch haftet Rigips nicht für Schäden infolge der Benutzung des Programms. Insbesondere ist jede Haftung für Schäden (z. B. eine fehlerhafte Planung) ausgeschlossen, die durch Verwendung von Berechnungsergebnissen oder von Daten oder Informationen aus dem Programm verursacht wurden. Der Haftungsausschluss gilt nicht für Schäden aus der Verletzung von Leben, Körper und Gesundheit sowie für Schäden, die auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung von Rigips oder auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung eines gesetzlichen Vertreters oder Erfüllungsgehilfen von Rigips beruhen.'
                        : 'Dieses Programm wurde sorgfältig programmiert und die Produktdaten sorgfältig zusammengestellt. Dennoch haftet ib-data nicht für Schäden infolge der Benutzung des Programms. Insbesondere ist jede Haftung für Schäden (z. B. eine fehlerhafte Planung) ausgeschlossen, die durch Verwendung von Berechnungsergebnissen oder von Daten oder Informationen aus dem Programm verursacht wurden. Der Haftungsausschluss gilt nicht für Schäden aus der Verletzung von Leben, Körper und Gesundheit sowie für Schäden, die auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung von ib-data oder auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung eines gesetzlichen Vertreters oder Erfüllungsgehilfen von ib-data beruhen.'}
                    </p>
                  </div>
                </Accordion>
              )}
            </div>
          </>
        )}
      </PageLayout>
    )
  }
}

export default SignUp
